// Dependencies
import React from "react"
import { graphql, Link } from "gatsby"
import PropTypes from "prop-types"
// Hooks
// import useMouse from "../hooks/useMouse";
// Components
import Accordian from "../components/Accordian"
import AnnotatedText from "../components/AnnotatedText"
import Layout from "../components/Layout"
import Header from "../components/Header"
import { Image } from "@unpic/react"
import RichText from "../components/RichText"
import Markdown from "../components/Markdown"
import Footer from "../components/Footer"
import NewsletterForm from "../components/NewsletterForm"
import Vimeo from "../components/Vimeo"
import { BlogIndexPageComponent } from "./blog-index"

export const resolveBlogLink = (category, slug) =>
  category && slug ? `/blog/${category}/${slug}` : "/404"

const BlogCategoryTemplate = ({ data, pageContext }) => {
  const { numPages, currentPage } = pageContext
  const defaultIntroduction =
    data.allContentfulSettings.nodes?.[0]?.blogDefaultIntroduction
  const { title, slug } = data.contentfulBlogCategory
  const articles = data.allContentfulBlogArticle.nodes
  const introduction =
    data.contentfulBlogCategory?.introduction ?? defaultIntroduction

  return (
    <BlogIndexPageComponent
      layout={{
        title: title,
      }}
      numPages={numPages}
      currentPage={currentPage}
      introduction={introduction}
      articles={articles}
      category={data.contentfulBlogCategory}
      relatedCategories={data.allContentfulBlogCategory.nodes}
    />
  )
}

export default BlogCategoryTemplate

export const pageQuery = graphql`
  query BlogCategoryTemplateQuery($slug: String!, $skip: Int!, $limit: Int!) {
    allContentfulSettings(limit: 1) {
      nodes {
        blogDefaultIntroduction {
          raw
        }
      }
    }
    contentfulBlogCategory(slug: { eq: $slug }) {
      title
      slug
      introduction {
        raw
      }
    }
    allContentfulBlogCategory(sort: { fields: [order], order: ASC }) {
      nodes {
        ...BlogCategoryFragment
      }
    }
    allContentfulBlogArticle(
      skip: $skip
      limit: $limit
      sort: { fields: [date], order: DESC }
      filter: {
        category: { slug: { eq: $slug } }
        contentful_id: { ne: "hEkj6bEcFEw6003GbXVBW" }
      }
    ) {
      nodes {
        ...BlogArticleCard
      }
    }
  }
`
